<template>
  <div class="home h5">
      <p class="latest-domain">https://fangshilian.net/---{{ $t('请截图保存GreenX防失联网址') }}</p>
      <div class="domain banner">
          <h3 class="http-title">{{ $t('最新域名') }}</h3>
          <div class="domain-list">
              <div class="click-copy h5">{{ $t('点击复制最新域名到浏览器打开') }}</div>
              <ul class="link-list">
                  <li class="copyLink" v-for="(item, index) in doMainList" :key="index" @click="copy(item, index)">
                      {{ item }}
                      <span :class="{'isCopySuccess': isCopySuccess && isCopyIndex === index}" class="copy-success">{{ $t('复制成功') }}</span>
                  </li>
              </ul>
              <div class="vpn">
                  {{ $t('【网络急救通道】请点击此处') }} <a href="https://hongtaiyang.vip/" target="_blank">{{ $t('《查看优化网络方式》') }}</a>{{ $t('此方式可以长期稳定访问APP和网页') }}
              </div>
          </div>
      </div>
      <div class="domain container">
          <h3 class="download-title">{{ $t('下载APP客户端') }}</h3>
          <div class="domain-list pc">
              <ul>
                  <li>
                      <span>{{ $t('IPhone手机Testflight下载') }}</span>
                      <a class="download-link" href="https://testflight.apple.com/join/WcffBUBg" target="_blank">
                          <svg class="bn-svg text-BasicBg h-6 w-6 flex-shrink-0" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.69 1.978c.133 1.149-.345 2.28-1.046 3.112-.73.819-1.9 1.445-3.037 1.364-.15-1.104.428-2.28 1.073-2.996.73-.815 1.997-1.438 3.01-1.48zm3.64 6.17c-.135.076-2.231 1.27-2.208 3.699.026 2.94 2.707 3.912 2.739 3.922-.015.069-.42 1.403-1.424 2.757-.84 1.193-1.72 2.359-3.116 2.38-.665.014-1.113-.168-1.58-.357-.488-.197-.996-.402-1.79-.402-.843 0-1.374.212-1.886.416-.442.177-.87.349-1.474.372-1.33.047-2.347-1.273-3.217-2.454-1.738-2.413-3.092-6.8-1.277-9.786.88-1.464 2.484-2.406 4.197-2.432.755-.014 1.48.262 2.114.504.485.186.918.35 1.273.35.312 0 .733-.158 1.224-.343.773-.291 1.72-.648 2.683-.552.659.018 2.536.247 3.745 1.924l-.003.002z" fill="currentColor"></path></svg>
                          {{ $t('GreenX IOS版下载') }}
                      </a>
                  </li>
                  <li>
                      <span>{{ $t('IPhone手机App Store下载') }}</span>
                      <a class="download-link" href="https://apps.apple.com/us/app/greenx/id6746765904" target="_blank">
                          <svg class="bn-svg text-BasicBg h-6 w-6 flex-shrink-0" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.69 1.978c.133 1.149-.345 2.28-1.046 3.112-.73.819-1.9 1.445-3.037 1.364-.15-1.104.428-2.28 1.073-2.996.73-.815 1.997-1.438 3.01-1.48zm3.64 6.17c-.135.076-2.231 1.27-2.208 3.699.026 2.94 2.707 3.912 2.739 3.922-.015.069-.42 1.403-1.424 2.757-.84 1.193-1.72 2.359-3.116 2.38-.665.014-1.113-.168-1.58-.357-.488-.197-.996-.402-1.79-.402-.843 0-1.374.212-1.886.416-.442.177-.87.349-1.474.372-1.33.047-2.347-1.273-3.217-2.454-1.738-2.413-3.092-6.8-1.277-9.786.88-1.464 2.484-2.406 4.197-2.432.755-.014 1.48.262 2.114.504.485.186.918.35 1.273.35.312 0 .733-.158 1.224-.343.773-.291 1.72-.648 2.683-.552.659.018 2.536.247 3.745 1.924l-.003.002z" fill="currentColor"></path></svg>
                          {{ $t('GreenX IOS版下载') }}
                      </a>
                      <p class="international-android">
                          {{ $t('目前仅支持马来西亚地区苹果账户下载') }}
                      </p>
                  </li>
                  <li>
                      <span>{{ $t('Android 下载') }}</span>
                      <a class="download-link" :href="android" target="_blank">
                          <svg class="bn-svg text-BasicBg h-6 w-6 flex-shrink-0" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M17.543 14.1a1 1 0 01-.997-.997 1 1 0 01.997-.997 1 1 0 01.997.997 1 1 0 01-.997.997zm-11.05 0a1 1 0 01-.996-.997 1 1 0 01.997-.997 1 1 0 01.997.997.993.993 0 01-.997.997zM17.9 8.082l1.994-3.458a.409.409 0 00-.155-.567.409.409 0 00-.567.156l-2.022 3.503a12.354 12.354 0 00-5.14-1.098c-1.857 0-3.594.394-5.14 1.098L4.848 4.213a.419.419 0 00-.568-.156.419.419 0 00-.155.567l1.994 3.458C2.689 9.948.348 13.423 0 17.52h24c-.32-4.107-2.67-7.583-6.1-9.44z" fill="currentColor"></path></svg>
                          {{ $t('GreenX安卓版下载') }}
                          <img class="android-qr-code"  :src="androidQrCode" alt="">
                      </a>
                  </li>
                  <li>
                      <span>{{ $t('Android 下载') }}</span>
                      <a class="download-link" href="https://capp-build.oss-accelerate.aliyuncs.com/GreenX/GreenX_6.2.7_6020719.apk" target="_blank">
                          <svg class="bn-svg text-BasicBg h-6 w-6 flex-shrink-0" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M17.543 14.1a1 1 0 01-.997-.997 1 1 0 01.997-.997 1 1 0 01.997.997 1 1 0 01-.997.997zm-11.05 0a1 1 0 01-.996-.997 1 1 0 01.997-.997 1 1 0 01.997.997.993.993 0 01-.997.997zM17.9 8.082l1.994-3.458a.409.409 0 00-.155-.567.409.409 0 00-.567.156l-2.022 3.503a12.354 12.354 0 00-5.14-1.098c-1.857 0-3.594.394-5.14 1.098L4.848 4.213a.419.419 0 00-.568-.156.419.419 0 00-.155.567l1.994 3.458C2.689 9.948.348 13.423 0 17.52h24c-.32-4.107-2.67-7.583-6.1-9.44z" fill="currentColor"></path></svg>
                          {{ $t('GreenX国际版下载') }}
                      </a>
                      <p class="international-android">
                          {{ $t('访问国际版需开启（网络加速器）才可正常使用') }}
                      </p>
                      <p class="warning">
                          {{ $t('重要提示！！若登录状态显示USDT充值显示（暂停），请重新连接网络加速器') }}
                      </p>
                  </li>
              </ul>
          </div>
          <div class="domain-list h5">
              <ul>
                  <li>
                      <h6>{{ $t('苹果手机') }}</h6>
                      <a class="download-link" href="https://testflight.apple.com/join/WcffBUBg" target="_blank">
                          <img class="iphone-logo" src="@/assets/img/ios-icon-86_86.png" alt="">
                          <div class="download-text">
                              <p class="download-title-h5">{{ $t('GreenX IOS版下载') }}</p>
                              <p class="download-info">{{ $t('Testflight下载') }}</p>
                          </div>
                          <img class="arrow" src="@/assets/img/箭头icon-60_60.png" alt="">
                      </a>
                  </li>
                  <li>
                      <h6>{{ $t('苹果手机') }}</h6>
                      <a class="download-link" href="https://apps.apple.com/us/app/greenx/id6746765904" target="_blank">
                          <img class="iphone-logo" src="@/assets/img/ios-icon-86_86.png" alt="">
                          <div class="download-text">
                              <p class="download-title-h5">{{ $t('GreenX IOS版下载') }}</p>
                              <p class="download-info">{{ $t('APP Store下载') }}</p>
                          </div>
                          <img class="arrow" src="@/assets/img/箭头icon-60_60.png" alt="">
                      </a>
                      <p class="warning-store">
                          {{ $t('目前仅支持马来西亚地区苹果账户下载') }}
                      </p>
                  </li>
                  <li>
                      <h6>{{ $t('安卓手机') }}</h6>
                      <a class="download-link" :href="android" target="_blank">
                          <img class="iphone-logo" src="@/assets/img/安卓icon-86_86.png" alt="">
                          <div class="download-text">
                              <p class="download-title-h5">{{ $t('GreenX安卓版下载') }}</p>
                              <p class="download-info">{{ $t('Android 下载') }}</p>
                          </div>
                          <img class="arrow" src="@/assets/img/箭头icon-60_60.png" alt="">
<!--                          <img class="android-qr-code"  :src="androidQrCode" alt="">-->
                      </a>
                  </li>
<!--                  <li>-->
<!--                      <span>{{ $t('Android 下载') }}</span>-->
<!--                      <a class="download-link" href="https://capp-build.oss-accelerate.aliyuncs.com/GreenX/GreenX_6.2.7_6020719.apk" target="_blank">-->
<!--                          <svg class="bn-svg text-BasicBg h-6 w-6 flex-shrink-0" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M17.543 14.1a1 1 0 01-.997-.997 1 1 0 01.997-.997 1 1 0 01.997.997 1 1 0 01-.997.997zm-11.05 0a1 1 0 01-.996-.997 1 1 0 01.997-.997 1 1 0 01.997.997.993.993 0 01-.997.997zM17.9 8.082l1.994-3.458a.409.409 0 00-.155-.567.409.409 0 00-.567.156l-2.022 3.503a12.354 12.354 0 00-5.14-1.098c-1.857 0-3.594.394-5.14 1.098L4.848 4.213a.419.419 0 00-.568-.156.419.419 0 00-.155.567l1.994 3.458C2.689 9.948.348 13.423 0 17.52h24c-.32-4.107-2.67-7.583-6.1-9.44z" fill="currentColor"></path></svg>-->
<!--                          {{ $t('GreenX国际版下载') }}-->
<!--                      </a>-->
<!--                      <p class="international-android">-->
<!--                          {{ $t('访问国际版需开启（网络加速器）才可正常使用') }}-->
<!--                      </p>-->
<!--                      <p class="warning">-->
<!--                          {{ $t('重要提示！！若登录状态显示USDT充值显示（暂停），请重新连接网络加速器') }}-->
<!--                      </p>-->
<!--                  </li>-->
              </ul>
          </div>
      </div>
      <div class="international-download-link">
          <router-link :to="{name: 'InternationalDownload'}">
              {{ $t('了解GreenX国际版下载') }}
              <img class="right-arrow" src="@/assets/img/Path.png" alt="">
          </router-link>
      </div>
      <div class="domain">
          <h4>{{ $t('下载安卓版谷歌验证器') }}</h4>
          <div class="domain-list pc">
              <ul>
                  <li>
                      <span>{{ $t('安卓版谷歌验证器 下载') }}</span>
                      <a class="download-link" :href="googleAuthPath">
                          <svg class="bn-svg text-BasicBg h-6 w-6 flex-shrink-0" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M17.543 14.1a1 1 0 01-.997-.997 1 1 0 01.997-.997 1 1 0 01.997.997 1 1 0 01-.997.997zm-11.05 0a1 1 0 01-.996-.997 1 1 0 01.997-.997 1 1 0 01.997.997.993.993 0 01-.997.997zM17.9 8.082l1.994-3.458a.409.409 0 00-.155-.567.409.409 0 00-.567.156l-2.022 3.503a12.354 12.354 0 00-5.14-1.098c-1.857 0-3.594.394-5.14 1.098L4.848 4.213a.419.419 0 00-.568-.156.419.419 0 00-.155.567l1.994 3.458C2.689 9.948.348 13.423 0 17.52h24c-.32-4.107-2.67-7.583-6.1-9.44z" fill="currentColor"></path></svg>
                          {{ $t('谷歌验证器下载') }}
                      </a>
                      <p class="international-android"> {{ $t('谷歌验证器可用于开启（账户安全）中的（谷歌验证码）') }}<i class="warning">{{ $t('重要提示！！设置谷歌验证码时，请注意保存谷歌密钥，防止丢失不易找回！') }}</i></p>
<!--                      <p class="international-android">{{ $t('点击下载查看GreenX设置谷歌验证码指南') }}<a class="google-auth" target="_blank" href="https://hongtaiyang.vip/files/GoogleAuthenticator.pdf">{{ $t('《谷歌验证器-GreenX账号如何设置谷歌验证码》') }}</a>-->
                      <p class="international-android">{{ $t('点击下载查看GreenX设置谷歌验证码指南') }}<a class="google-auth" target="_blank" href="https://hongtaiyang.vip/files/%E8%B0%B7%E6%AD%8C%E9%AA%8C%E8%AF%81%E5%99%A8-GreenX%E8%B4%A6%E5%8F%B7%E5%A6%82%E4%BD%95%E8%AE%BE%E7%BD%AE%E8%B0%B7%E6%AD%8C%E9%AA%8C%E8%AF%81%E7%A0%81.pdf">{{ $t('《谷歌验证器-GreenX账号如何设置谷歌验证码》') }}</a>
                          ----<span class="microsoft"><router-link :to="{name: 'GoogleAuthenticator'}">{{$t('了解微软Authenticator')}}</router-link></span>
                      </p>
                  </li>
              </ul>
          </div>
          <div class="domain-list h5">
              <ul>
                  <li>
                      <a class="download-link" :href="googleAuthPath" target="_blank">
                          <img class="iphone-logo" src="@/assets/img/安卓icon-86_86.png" alt="">
                          <div class="download-text">
                              <p class="download-title-h5">{{ $t('谷歌验证器下载') }}</p>
                              <p class="download-info">{{ $t('安卓版谷歌验证器下载') }}</p>
                          </div>
                          <img class="arrow" src="@/assets/img/箭头icon-60_60.png" alt="">
                      </a>
                  </li>
              </ul>
              <p class="international-android"> {{ $t('谷歌验证器可用于开启（账户安全）中的（谷歌验证码）') }}</p>
              <p class="warning">{{ $t('重要提示！！设置谷歌验证码时，请注意保存谷歌密钥，防止丢失不易找回！') }}</p>
              <!--                      <p class="international-android">{{ $t('点击下载查看GreenX设置谷歌验证码指南') }}<a class="google-auth" target="_blank" href="https://hongtaiyang.vip/files/GoogleAuthenticator.pdf">{{ $t('《谷歌验证器-GreenX账号如何设置谷歌验证码》') }}</a>-->
              <p class="international-android">{{ $t('点击下载查看GreenX设置谷歌验证码指南') }}<a class="google-auth" target="_blank" href="https://hongtaiyang.vip/files/%E8%B0%B7%E6%AD%8C%E9%AA%8C%E8%AF%81%E5%99%A8-GreenX%E8%B4%A6%E5%8F%B7%E5%A6%82%E4%BD%95%E8%AE%BE%E7%BD%AE%E8%B0%B7%E6%AD%8C%E9%AA%8C%E8%AF%81%E7%A0%81.pdf">{{ $t('《谷歌验证器-GreenX账号如何设置谷歌验证码》') }}</a>
                  ----<span class="microsoft"><router-link :to="{name: 'GoogleAuthenticator'}">{{$t('了解微软Authenticator')}}</router-link></span>
              </p>
          </div>

      </div>
  </div>
</template>

<script lang="ts" setup>
import { reactive, ref } from 'vue';


const doMainList = reactive([
    'www.greeng.vip',
    'www.green-x.sbs',
    'www.green-x.icu'
])

const android = ref<string>('https://capp-build.oss-cn-hangzhou.aliyuncs.com/GreenX/GreenX_Release_6.5.6_6030028.apk');
const androidQrCode = ref<string>('');
const isCopySuccess = ref<boolean>(false);
const isCopyIndex = ref<number>(0);
// const googleAuthPath = ref<string>('https://hongtaiyang.vip/files/Authenticator.apk') //暂时隐藏此版本
const googleAuthPath = ref<string>('https://hongtaiyang.vip/files/谷歌身份验证器.apk')

// 复制文本
const copy = (str: string, index: number) => {
    isCopyIndex.value = index;
    const textarea = document.createElement('textarea');
    textarea.value = str;
    document.body.appendChild(textarea);
    textarea.select();  // 选择文本
    try {
        // 执行复制命令
        document.execCommand('copy');
        isCopySuccess.value = true;
        setTimeout(() => {
            isCopySuccess.value = false;
        }, 1500)
        console.log("复制成功")
    } catch (err) {
        console.error('复制失败：', err);
    }
    // 移除临时文本框
    document.body.removeChild(textarea);
}
</script>

<style lang="scss">
.home {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 50px;
    position: relative;
    .latest-domain {
        text-align: center;
        height: 25px;
        line-height: 25px;
        background-color: rgba(255,255,255,0.3);
        padding: 0 15px;
        border: 1px solid rgba(255,255,255,0.8);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: none;
        font-size: 12px;
    }
    .international-download-link {
        display: none;
    }
    .domain {
        width: 1200px;
        margin-bottom: 50px;
        h3 {
            font-size: 20px;
            text-align: center;
            margin-bottom: 50px;
            font-weight: 600;

        }
        h4 {
            padding: 0 15px;
            font-size: 20px;
            text-align: center;
            font-weight: 600;
        }
        .domain-list {

            &.pc {
                display: block;
            }
            &.h5 {
                display: none;
            }
            font-size: 16px;

            .click-copy {
                font-size: 14px;
                text-align: center;
            }
            .vpn {
                margin-top: 15px;
                font-size: 14px;
                text-align: center;
                a{
                    color: #19bca0;
                }
            }
            ul {
                margin-top: 20px;
                display: flex;
                justify-content: space-between;
                li {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    position: relative;

                    span {
                        font-weight: 500;
                        color: #000;
                    }
                    .google-auth {
                        color: #19bca0;
                    }

                    .international-android {
                        padding: 0 15px;
                        font-size: 12px;
                        margin-top: 5px;
                        text-align: center;

                        .microsoft {
                            text-decoration: underline;
                            color: #19bca0;
                            a{
                                color: #19bca0;
                            }
                        }
                    }
                    .copy-success {
                        position: absolute;
                        background-color: rgba(0,0,0,.6);
                        color: #fff;
                        font-size: 12px;
                        padding: 0 10px;
                        -webkit-border-radius: 4px;
                        -moz-border-radius: 4px;
                        border-radius: 4px;
                        display: none;

                        &.isCopySuccess {
                            display: block;
                        }
                    }
                    &.copyLink {
                        cursor: pointer;
                        color: #19bca0;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        font-size: 12px;
                    }

                    .download-link {
                        padding: 10px 30px;
                        background-color: rgba(25, 188, 160, 1);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border-radius: 5px;
                        color: #fff;
                        margin-top: 10px;
                        position: relative;
                        svg {
                            width: 20px;
                            font-size: 18px;
                            margin-right: 10px;
                        }
                        .android-qr-code {
                            z-index: 2;
                            display: none;
                            width: 160px;
                            position: absolute;
                            top: 50px;
                            -webkit-border-radius: 8px;
                            -moz-border-radius: 8px;
                            border-radius: 8px;
                        }
                        &:hover {
                            .android-qr-code {
                                display: block;
                            }
                        }
                    }
                }
            }
        }

        .notice-container {
            display: flex;
            .notice-title {
                width: 200px;
                height: 600px;
                overflow: scroll;
                background-color: #fff;
                -webkit-border-radius: 8px;
                -moz-border-radius: 8px;
                border-radius: 8px;
                box-shadow: 4px 4px 4px 4px rgba(0, 0, 0, 0.06);
                padding: 15px;

                .notice-title-text {
                    margin-bottom: 15px;
                    cursor: pointer;
                    color: rgba(96, 98, 102, 1);
                    &:hover {
                        color: #000;
                        font-weight: 500;
                    }
                    &.native {
                        color: #000;
                        font-weight: 500;
                    }
                }
            }
            .notice-content {
                padding: 15px;
                margin-left: 30px;
                flex: 1;
                min-height: 600px;
                background-color: #fff;
                -webkit-border-radius: 8px;
                -moz-border-radius: 8px;
                border-radius: 8px;
                box-shadow: 4px 4px 4px 4px rgba(0, 0, 0, 0.06);

                .notice-content-title {
                    font-size: 20px;
                    color: #000;
                    font-weight: 500;
                    margin-bottom: 30px;
                }

                .notice-info {
                    a {

                    }
                }
            }
        }
    }
}

@media (max-width: 960px) {
    .home.h5 {
        margin-top: 0;
        background-color: #e2f3fb;
        display: block;
        padding-bottom: 50px;
        .latest-domain {
           display: block;
        }
        .banner {
            background-image: url('@/assets/img/bg.png');
            background-repeat: repeat;
            background-size:cover;
            padding: 20px 15px 0;
            margin-bottom: 35px;
        }
        .container {
            margin-bottom: 30px;
            .download-title {
                font-size: 18px;
            }
        }
        .international-download-link {
            display: block;
            padding: 0 15px;
            margin-bottom: 30px;
            font-weight: 600;
            font-size: 13px;

            a {
                color: #19bca0;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                height: 30px;
                img {
                    margin-top: -3px;
                    width: 20px;
                }
            }
            .right-arrow {
                width: 20px;
            }
        }
        .domain {
            width: 100%;

            h4 {
                font-size: 18px;
            }
            .http-title {
                text-align: left;
                font-size: 25px;
                color: #384361;
            }

            .domain-list {
                .vpn {
                    text-align: left;
                    padding: 0;
                    color: #747c94;
                    font-size: 12px;
                }
                &.h5 {
                    .warning-store {
                        font-size: 13px;
                        margin-top: 5px;
                        text-align: right;
                        width: 100%;
                    }
                    .international-android {
                        margin-top: 30px;
                        font-size: 12px;
                        color: #747c94;

                        a {
                            color: #19bca0;
                        }
                    }
                    .warning {
                        text-align: left;
                        padding: 0;
                        font-size: 12px;
                    }
                    ul {
                        li {
                            align-items: flex-start;
                        }
                    }
                    padding:0 15px;
                    display: block;

                    h6 {
                        font-size: 14px;
                        font-weight: 600;
                        text-align: left;
                        color: #000000;
                    }
                    .download-link {
                        width: 100%;
                        justify-content: space-between;
                        -webkit-border-radius: 10px;
                        -moz-border-radius: 10px;
                        border-radius: 10px;
                        padding: 10px 15px;
                        .download-text {
                            display: flex;
                            align-items: center;
                            flex-direction: column;
                            justify-content: center;
                            flex: 1;
                            padding: 0 20px;
                        }

                        .iphone-logo {
                            width: 30px;
                        }
                        .arrow {
                            width: 25px;
                        }
                        .download-title-h5 {
                            font-weight: 600;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            max-width: 150px;
                            font-size: 14px;
                        }
                        .download-info {
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            max-width: 150px;
                            font-size: 13px;
                        }
                    }
                }
                &.pc {
                    display: none;
                }
                .click-copy.h5 {
                    text-align: left;
                    font-size: 14px;
                    font-weight: 500;
                    margin-top: 20px;
                }
                .link-list {
                    flex-direction: row;
                    li {
                        font-size: 12px;
                        border: 1px solid #19bca0;
                        -webkit-border-radius: 30px;
                        -moz-border-radius: 30px;
                        border-radius: 30px;
                        height: 30px;
                        line-height: 28px;
                        margin-right: 8px;
                        font-weight: 600;
                        &:last-child {
                            margin-right: 0;
                        }
                    }
                }
                ul {
                    flex-direction: column;
                    margin-top: 0;
                    li {
                        margin-bottom: 10px;
                        margin-top: 20px;
                    }
                }
            }
            h3 {
                margin-bottom: 0px;
            }

            .warning {
                padding: 0 15px;
                text-align: center;
            }
        }

    }
}
</style>